module.exports = __webpack_public_path__ + "media/images/application/template/logos/iso-45001-2022-b641ae6a037e15e5107547213d17ce29.png";